import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <section className="relative pt-16 pb-12 md:pt-24 md:pb-20 px-4 overflow-hidden" data-id="element-33">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/10 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-34"></div>

      <div className="max-w-5xl mx-auto text-center" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-36">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black leading-tight mb-3 text-white" data-id="element-37">
            Dejá de improvisar.
          </h1>
          <p className="text-xl md:text-2xl lg:text-3xl font-bold text-gold mb-2" data-id="element-38">
            Empezá a entrenar como un profesional.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative max-w-lg mx-auto mt-8 mb-8 md:max-w-xl" data-id="element-39">
          <a href="#compra" className="block cursor-pointer group" data-id="element-40">
            <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full group-hover:bg-gold/30 transition-colors duration-500" data-id="element-41"></div>
            <img src="https://cdn.magicpatterns.com/uploads/m2TsdtAaSTsieyefxt48qb/MOCKUP_PNG.png" alt="Entrenador de Futsal 360°" className="relative z-10 w-[70%] mx-auto h-auto drop-shadow-2xl group-hover:scale-[1.02] transition-transform duration-500" data-id="element-42" />
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-43">
          <CtaButton className="w-full md:w-auto" data-id="element-44" />
        </motion.div>
      </div>
    </section>;
}